import {Component, OnInit, ChangeDetectorRef, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {SenatorService} from '../../../../../api/services/senator.service';
import {SenatorTrades} from '../../../../../api/models/senator-trades';
import GetSenatorTradesByFilingIdParams = SenatorService.GetSenatorTradesByFilingIdParams;
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatTableDataSource} from '@angular/material/table';
import {TradeOperationModel} from '../../../../../api/models/trade-operation-model';
import {TradeUpdateStatusEnum} from '../../../../../api/models/trade-update-status-enum';
import {TradeAmendmentModel} from '../../../../../api/models/trade-amendment-model';
import {CongressType} from '../../../../../api/models/congress-type';
import UpdateMultipleTradeStatusParams = SenatorService.UpdateMultipleTradeStatusParams;
import {AmendedTradesHistory} from '../../../../../api/models/amended-trades-history';
import {SelectionModel} from '@angular/cdk/collections';
import {ReverseAmendedTrade} from "../../../../../api/models/reverse-amended-trade";


@Component({
  selector: 'app-transaction-amendments',
  templateUrl: './transaction-amendments.component.html',
  styleUrls: ['./transaction-amendments.component.css']
})


export class TransactionAmendmentsComponent implements OnInit {
  @ViewChild('paginatorFirst') paginatorFirst: MatPaginator;
  @ViewChild('paginatorSecond') paginatorSecond: MatPaginator;


  displayedColumns1: string[] = ['select', 'no', 'status', 'amendmentStatus', 'transactionDate', 'transactionType', 'issuerName', 'ticker', 'owner', 'securityType', 'amount', 'comments', 'capitalGain'];
  displayedColumns2: string[] = ['select', 'no', 'status', 'amendmentStatus', 'transactionDate', 'transactionType', 'issuerName', 'ticker', 'owner', 'securityType', 'amount', 'comments', 'capitalGain'];
  matTableDataSource1: MatTableDataSource<SenatorTrades> = new MatTableDataSource<SenatorTrades>(null);
  matTableDataSource2: MatTableDataSource<SenatorTrades> = new MatTableDataSource<SenatorTrades>(null);

  readonly OLD_FILE_TRADES_TABLE = 'OLD FILE TRADES TABLE';
  readonly NEW_FILE_TRADES_TABLE = 'NEW FILE TRADES TABLE';
  currentTable: string;
  parties = [
    {value: 'Representative', viewValue: 'Representative'},
    {value: 'Senator', viewValue: 'Senator'}
  ];
  fileSearchFilterOld: GetSenatorTradesByFilingIdParams;
  fileSearchFilterNew: GetSenatorTradesByFilingIdParams;
  filterCongressType = 'Representative';
  table1Loading = false;
  table2Loading = false;

  pageSize: number;
  pageSize1: number;
  pageSizeOptions: number[];
  pageEvent: PageEvent;
  tradeUpdateActions = TradeUpdateStatusEnum.values();
  oldTrade: SenatorTrades;
  newTrade: SenatorTrades;
  amendmentHistory: AmendedTradesHistory[] = [];
  showPopover = false;
  amendmentHistoryTradeId: number;

  selection1 = new SelectionModel<SenatorTrades>(true, []);
  selection2 = new SelectionModel<SenatorTrades>(true, []);

  selectedPairs: {
    tradeOperationModel: TradeOperationModel,
    color: string
  }[];
  currentPair: TradeOperationModel;
  pairToUnselect: TradeOperationModel;
  tradeToBeReverse: SenatorTrades = null;

  isBackToBackReq: boolean;

  letters = '0123456789ABCDEF';
  color = '#';

  constructor(private _senatorService: SenatorService, public snackBar: MatSnackBar, private changeDetectorRefs: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.fileSearchFilterOld = {
      filingId: null,
      congressType: null
    };
    this.fileSearchFilterNew = {
      filingId: null,
      congressType: null
    };
    this.pageSize = 10;
    this.pageSize1 = 10;
    this.pageSizeOptions = [10, 20, 50];
    this.currentPair = {};
    this.selectedPairs = [];
    this.isBackToBackReq = false;
  }

  getTradesByFiling(tableType: string, filter: GetSenatorTradesByFilingIdParams) {
    this.currentTable = tableType;

    const params: GetSenatorTradesByFilingIdParams = {
      congressType: this.filterCongressType,
      filingId: filter.filingId
    };

    if (typeof filter.filingId !== 'number') {
      this.openSnackBar('Error: Invalid id, only number input allows', 'Close');
      this.table1Loading = this.table2Loading = false;
      return;
    }

    let response: SenatorTrades[] = [];

    this._senatorService.getSenatorTradesByFilingId(params).subscribe((res: SenatorTrades[]) => {
      response = res;

    }, (err) => {
      this.openSnackBar(err.error.message, 'Close');
      switch (this.currentTable) {
        case this.OLD_FILE_TRADES_TABLE:
          this.table1Loading = false;
          break;
        case this.NEW_FILE_TRADES_TABLE:
          this.table2Loading = false;
          break;
      }
      this.table1Loading = false;
    }, () => {

      switch (this.currentTable) {
        case this.OLD_FILE_TRADES_TABLE:
          this.table1Loading = false;
          this.initTradesData(response);
          if (this.isBackToBackReq) {
            this.isBackToBackReq = false;
            this.getTradesByFiling(this.NEW_FILE_TRADES_TABLE, this.fileSearchFilterNew);
          }
          break;
        case this.NEW_FILE_TRADES_TABLE:
          this.table2Loading = false;
          this.initTradesData(response);
          break;
      }
    });
  }

  initTradesData(trades: SenatorTrades[]) {

    switch (this.currentTable) {
      case this.OLD_FILE_TRADES_TABLE:
        if (trades.length < 1)
          this.oldTrade = null;
        this.matTableDataSource1.data = trades;
        this.matTableDataSource1.paginator = this.paginatorFirst;
        break;
      case this.NEW_FILE_TRADES_TABLE:
        if (trades.length < 1)
          this.newTrade = null;
        this.matTableDataSource2.data = trades;
        this.matTableDataSource2.paginator = this.paginatorSecond;
        break;
    }
    this.changeDetectorRefs.detectChanges();
    this.selection1 = new SelectionModel<SenatorTrades>(true, []);
    this.selection2 = new SelectionModel<SenatorTrades>(true, []);
    this.tradeToBeReverse = null;
    this.color = '#';
    this.currentPair = {};
    this.selectedPairs = [];

  }

  applyFilterAndSearchTrades(tableType: string) {

    if (this.fileSearchFilterOld.filingId === this.fileSearchFilterNew.filingId) {
      this.openSnackBar('Warning! Same files can not be loaded.', 'close');
      return;
    }

    this.currentTable = tableType;
    this.selectedPairs = [];
    this.currentPair = {};

    switch (tableType) {
      case this.OLD_FILE_TRADES_TABLE:
        this.table1Loading = true;
        this.getTradesByFiling(tableType, this.fileSearchFilterOld);
        break;

      case this.NEW_FILE_TRADES_TABLE:
        this.table2Loading = true;
        this.getTradesByFiling(tableType, this.fileSearchFilterNew);
        break;
    }

  }

  updateTradeStatus(tradeUpdateAction: TradeUpdateStatusEnum) {

    if (this.filterCongressType === 'Senator' && tradeUpdateAction == this.tradeUpdateActions[2]) {
      this.table1Loading = true;
    } else {
      this.table1Loading = true;
      this.table2Loading = true;
    }

    let response: TradeAmendmentModel[];

    const params: UpdateMultipleTradeStatusParams = {
      tradeOperation: this.selectedPairs.map(el => el.tradeOperationModel),
      amendmentAction: tradeUpdateAction,
    };

    this._senatorService.updateMultipleTradeStatus(params).subscribe((res: TradeAmendmentModel[]) => {
      response = res;

    }, (err) => {
      this.openSnackBar(err.error.message, 'Close');

      this.table1Loading = false;
      this.table2Loading = false;
    }, () => {
      this.table1Loading = false;
      this.table2Loading = false;

      this.selectedPairs = [];
      this.currentPair = {};

      this.openSnackBar(`Trades have been successfully marked as ${tradeUpdateAction} `, 'Close');
      this.selection1 = new SelectionModel<SenatorTrades>(true, []);
      this.selection2 = new SelectionModel<SenatorTrades>(true, []);

      this.getTradesByFiling(this.OLD_FILE_TRADES_TABLE, this.fileSearchFilterOld);
      this.isBackToBackReq = true;

    });
  }

  onCheckBoxChangeOfOldFileTable(event: any, row: SenatorTrades) {
    if (event.checked) {
      if (this.selection1.selected.length === 1 && this.selection2.selected.length < 1) {
        this.tradeToBeReverse = row
      }
      // check if 2nd checkbox is checked without completing the pair with new Old file table
      if (this.currentPair.oldFileTradeId !== undefined) {
        if (this.filterCongressType === 'Senator') {

        } else {
          this.openSnackBar(`Please complete trade pair, or unselect the current trade`, 'Close');
          this.unselectSelection(true, row, this.OLD_FILE_TRADES_TABLE);
          return null;
        }
      }

      this.currentPair.congressType = <CongressType>row.congressType;
      this.currentPair.oldFileId = row.filingId;
      this.currentPair.oldFileTradeId = row.tradeId;

      if (this.filterCongressType === 'Senator' && this.currentPair.oldFileTradeId !== undefined) {
        this.openSnackBar('Warning! Amendment and Duplicate operation allowed with equal trade pairs', 'Close');
        this.pushNewPair();
      } else if (this.currentPair.oldFileTradeId !== undefined && this.currentPair.newFileTradeId !== undefined) {
        this.pushNewPair();
      }

    }
    if (!event.checked) {
      if (this.selectedPairs.find(el => el.tradeOperationModel.oldFileTradeId === row.tradeId) !== undefined) {
        this.pairToUnselect = this.selectedPairs.find(el => el.tradeOperationModel.oldFileTradeId === row.tradeId).tradeOperationModel;
        this.selectedPairs = this.selectedPairs.filter(el => el.tradeOperationModel.oldFileTradeId !== row.tradeId);
        this.unselectSelection();
      } else {
        if (this.filterCongressType === 'Representative' && this.currentPair.oldFileTradeId !== row.tradeId) {
          this.unselectSelection(true, row, this.OLD_FILE_TRADES_TABLE, false);
        } else {
          this.unselectSelection(true, row, this.OLD_FILE_TRADES_TABLE, true);
        }
      }
      if (this.selection1.selected.length === 0 && this.selection2.selected.length === 0) {
        this.tradeToBeReverse = null;
      }
    }
  }

  onCheckBoxChangeOfNewFileTable(event: any, row: SenatorTrades) {

    if (event.checked) {

      if (this.selection2.selected.length === 1 && this.selection1.selected.length < 1) {
        this.tradeToBeReverse = row
      }
      // check if 2nd checkbox is checked without completing the pair with new Amendment file table
      if (this.currentPair.newFileTradeId !== undefined) {
        this.openSnackBar(`Please complete trade pair, or unselect the current trade`, 'Close');
        this.unselectSelection(true, row, this.NEW_FILE_TRADES_TABLE);
        return;
      }
      this.currentPair.congressType = <CongressType>row.congressType;
      this.currentPair.newFileId = row.filingId;
      this.currentPair.newFileTradeId = row.tradeId;
      // this.selectedPairs.filter(el => el.tradeOperationModel.newFileId === row.newFileId) === true
      if (this.filterCongressType == 'Senator' && this.selectedPairs.length > 0) {
        if (this.selectedPairs[this.selectedPairs.length - 1].tradeOperationModel.newFileTradeId === undefined) {
          this.selectedPairs[this.selectedPairs.length - 1].tradeOperationModel.newFileId = this.currentPair.newFileId;
          this.selectedPairs[this.selectedPairs.length - 1].tradeOperationModel.newFileTradeId = this.currentPair.newFileTradeId;
          this.currentPair = {};
        }

      } else if (this.currentPair.oldFileTradeId !== undefined && this.currentPair.newFileTradeId !== undefined) {
        this.pushNewPair();
      }
    }
    if (!event.checked) {
      if (this.selectedPairs.find(el => el.tradeOperationModel.newFileTradeId === row.tradeId) !== undefined) {
        this.pairToUnselect = this.selectedPairs.find(el => el.tradeOperationModel.newFileTradeId === row.tradeId).tradeOperationModel;
        this.selectedPairs = this.selectedPairs.filter(el => el.tradeOperationModel.newFileTradeId !== row.tradeId);
        this.unselectSelection();
      } else {
        if (this.filterCongressType === 'Representative' && this.currentPair.newFileTradeId !== row.tradeId) {
          this.unselectSelection(true, row, this.NEW_FILE_TRADES_TABLE, false);
        } else {
          this.unselectSelection(true, row, this.NEW_FILE_TRADES_TABLE, true);
        }
      }
      if (this.selection2.selected.length === 0 && this.selection1.selected.length === 0) {
        this.tradeToBeReverse = null;
      }
    }
  }

  unselectSelection(single?: boolean, row?: SenatorTrades, tableType?: string, clear?: boolean) {

    if (single) {
      switch (tableType) {
        case this.OLD_FILE_TRADES_TABLE:
          this.selection1 = new SelectionModel<SenatorTrades>(true, this.selection1.selected.filter(el => el.tradeId !== row.tradeId));
          break;
        case this.NEW_FILE_TRADES_TABLE:
          this.selection2 = new SelectionModel<SenatorTrades>(true, this.selection2.selected.filter(el => el.tradeId !== row.tradeId));
          break;
      }
      if (clear) {
        this.color = '#';
        this.currentPair = {};
      }

    } else {
      this.selection1 = new SelectionModel<SenatorTrades>(true, this.selection1.selected.filter(el => el.tradeId !== this.pairToUnselect.oldFileTradeId));
      this.selection2 = new SelectionModel<SenatorTrades>(true, this.selection2.selected.filter(el => el.tradeId !== this.pairToUnselect.newFileTradeId));

      this.color = '#';
      this.currentPair = {};
    }
  }

  pushNewPair() {
    this.getRandomColor();
    const tempCurrentPair: {
      tradeOperationModel: TradeOperationModel,
      color: string
    } = {
      tradeOperationModel: this.currentPair,
      color: this.color
    };
    this.selectedPairs.push(tempCurrentPair);
    this.color = '#';
    this.currentPair = {};
  }

  isRowSelected(row: SenatorTrades): boolean {
    if (this.selectedPairs.length > 0) {
      const result = (this.selectedPairs.find(el => el.tradeOperationModel.oldFileTradeId === row.tradeId || el.tradeOperationModel.newFileTradeId === row.tradeId) !== undefined);
      return result;
    }
  }

  operationNotAllowed(): boolean {
    if (this.filterCongressType === 'Senator') {
      return this.selectedPairs.find(el => el.tradeOperationModel.newFileTradeId === undefined) !== undefined;
    } else {
      return false;
    }
  }

  getPairedRow(row: SenatorTrades): {
    tradeOperationModel: TradeOperationModel,
    color: string
  } {
    return this.selectedPairs.find(el => el.tradeOperationModel.oldFileTradeId === row.tradeId || el.tradeOperationModel.newFileTradeId === row.tradeId);
  }

  getRandomColor() {
    this.color = '#';
    for (let i = 0; i < 6; i++) {
      this.color += this.letters[Math.floor(Math.random() * 16)];
    }
  }

  getAmendmentHistory(tradeId: number) {
    this.amendmentHistoryTradeId = tradeId;
    this.showPopover = true;
    this._senatorService.getAmendedTradeHistory(tradeId).subscribe((res: AmendedTradesHistory[]) => {
      this.amendmentHistory = res;
    }, (err) => {
      this.openSnackBar(`${err.error.message} `, 'Close');

    }, () => {

    });
  }

  reverseTradeStatus() {
    const params: ReverseAmendedTrade = {
      amendmentSessionId: this.tradeToBeReverse.amdSessionId,
      congressType: <CongressType>this.tradeToBeReverse.congressType,
      filingId: this.tradeToBeReverse.filingId,
      mergedFilingId: this.tradeToBeReverse.mergedFilingId,
      mergedTradeId: this.tradeToBeReverse.mergedTradeId,
      tradeId: this.tradeToBeReverse.tradeId,
    };
    this.showPopover = true;
    let response;
    this._senatorService.reverseAmendedTrade(params).subscribe((res: TradeAmendmentModel[]) => {
      response = res;
    }, (err) => {
      this.openSnackBar(`${err.error.message} `, 'Close');

    }, () => {
      this.tradeToBeReverse = null;
      this.openSnackBar(`Operation has been successfully reversed.`, 'Close');

      this.getTradesByFiling(this.OLD_FILE_TRADES_TABLE, this.fileSearchFilterOld);
      this.isBackToBackReq = true;
    });
  }

  hidePopover() {
    this.showPopover = false;
    this.amendmentHistoryTradeId = null;
    this.amendmentHistory = [];
  }

  getTableRow(row: SenatorTrades, tableType: string) {

    switch (tableType) {
      case this.OLD_FILE_TRADES_TABLE:
        this.oldTrade = row;
        break;
      case this.NEW_FILE_TRADES_TABLE:
        this.newTrade = row;
        break;
    }
  }

  onPaginateChange(event: PageEvent) {
    this.pageSize = event.pageSize;
  }

  onTopFilterChange() {
    this.matTableDataSource1 = new MatTableDataSource<SenatorTrades>([]);
    this.matTableDataSource2 = new MatTableDataSource<SenatorTrades>([]);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }
}
